import { Component, Input, OnChanges } from '@angular/core';
import { formatNumber } from '../../../utils/common';

@Component({
  selector: 'icc-total-send',
  templateUrl: './icc-total-send.component.html',
  styleUrls: ['./icc-total-send.component.less'],
})
export class IccTotalSendComponent implements OnChanges {
  constructor() {}

  @Input() reportType: number;
  @Input() count: number;
  @Input() successRatio: any;
  @Input() ringRatio: any;
  @Input() sameRatio: any;

  numList: Array<string>;

  ringRatioNum: number;
  sameRatioNum: number;

  ngOnChanges() {
    if (typeof this.count === 'string') {
      this.count = Number(this.count);
    }
    if (typeof this.count === 'number') {
      const numStrings = formatNumber(this.count);
      this.numList = numStrings.split('');
    }
    if (this.ringRatio) {
      this.ringRatioNum = Number(this.ringRatio.replace(/,/g, ''));
    }
    if (this.sameRatio) {
      this.sameRatioNum = Number(this.sameRatio.replace(/,/g, ''));
    }
  }
}
